import React from 'react';
import classnames from 'classnames';

import TextComponent from 'shared/components/TextComponent';

const Revision = (props) => {
  const name = 'revision';
  const {
    label,
    inputId,
    parameters,
    onChangeParameter,
    groupName,
    required,
    tooltip,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name="revision"
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      groupName={groupName}
      tooltip={tooltip}
      className={classnames('revision', className)}
      disabled={disabled}
      {...props} />
  );
};

Revision.defaultProps = {
  groupName: 'parameters',
  inputId: 'revision',
  tooltip: Spree.helpForParameters.revision,
  label: Spree.translations.parameters.revision,
  required: false,
};

export default Revision;
